import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

import 'react-loading-skeleton/dist/skeleton.css';

import './cardSkeleton.scss';

type CardSkeletonProps = {
  count: number;
  className?: string;
};

const CardSkeleton: React.FC<CardSkeletonProps> = ({ count, className }) => (
  <SkeletonTheme baseColor="#b6b6b6" highlightColor="#dedede" inline>
    {Array(count)
      .fill(0)
      .map((_, ind) => (
        <div key={ind} className={`skeleton_container ${className}`}>
          <Skeleton className="skeleton_image" />
          <div className="skeleton_wrapper">
            {Array(1)
              .fill(0)
              .map((_, index) => (
                <Skeleton key={index} className="skeleton_text" />
              ))}
            {Array(1)
              .fill(0)
              .map((_, index) => (
                <Skeleton key={index} className="skeleton_desc" />
              ))}
          </div>
        </div>
      ))}
  </SkeletonTheme>
);

export default CardSkeleton;
